import { Card, Tag } from "antd";
// import { UserType } from "../../ducks/types";
import { POSITION_NAMES } from "../../../../config/utils";
import { useAppSelector } from "../../../../config/hooks";

// type PropsType = {
//   data: UserType | null;
// };

export default function MyJobDetails() {
  // const { data } = props;

  const myProfileData = useAppSelector(
    (state) => state?.myProfile?.userData?.data
  );

  return (
    <Card className="jobDetailsData">
      <div className="cardInfo">
        <h4>Job details</h4>
        <div className="profileWrapper">
          <div className="profileDetail" style={{ marginBottom: 0 }}>
            <div className="profileLabel">Position:</div>
            <div className="profileValue">
              <Tag className="red_tag">
                {/* {data?.type?.replace("_", " ")} */}

                {myProfileData?.position_id
                  ? POSITION_NAMES[myProfileData?.position_id]
                  : myProfileData?.type?.replace(/_/g, " ")?.toLowerCase()}
              </Tag>
            </div>
          </div>
          <div className="profileDetail">
            <div className="profileLabel">Joined company:</div>
            <div className="profileValue">December 5, 2025</div>
          </div>
        </div>
      </div>
    </Card>
  );
}
